import { toast } from "react-toastify";
export function errosHandler(err: any, genericErrorMessage?: string) {
  const erroData = err && err.response && err.response.data ? err.response.data : undefined;

  const statusCode: number = erroData?.statusCode ?? 500;
  const mensagem: string =
    erroData?.message ?? 'Erro interno, contate o suporte';

  if (erroData && erroData.data) {
    const mensagemAjustada = erroData.data.join(' ') + '\n';
    return {
      mensagem: mensagemAjustada,
      data: erroData ?? null,
      statusCode: statusCode ?? 500,
    };
  }

  if (statusCode == 401) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("permissions");
    localStorage.removeItem("idUserLogado");
  }

  return {
    mensagem,
    data: erroData ?? null,
    statusCode: statusCode ?? 500,
  };
}

export const toastError = (error: any): any => {
  return toast.error(
    (error as any)?.data?.message || (error as any)?.mensagem
  );
}
